import '@epitome-analytics/dashboard-kit/tokens.css';
import './app.css';

import * as echarts from 'echarts/core';
import { epitomeTheme } from '@epitome-analytics/dashboard-kit/theme';
import { mount } from 'svelte';
import App from './App.svelte';

echarts.registerTheme('epitome', epitomeTheme);

const target = document.getElementById('app');
if (!target) throw new Error('mount target #app missing from index.html');

const app = mount(App, { target });
export default app;
